import idCreator from "src/helpers/id-creator";

/* 
  INFO: This function will be control your localstorage datas for EjGtmId value. If you use homepage, listing-search, listing-detail and other main pages this function will work and create new random id.
  PARAMETERS: type(type: string, info: page name)
  IMPORT: import setSearchId from 'src/helpers/google-tag-manager/set-search-id';
  USAGE: setSearchId('homepage').then((result) => {
          console.log(result);
        });
*/
const setSearchId = (type, isOtherPage = false) => {
  return new Promise((resolve) => {
    if (!localStorage.getItem("EjGtmId")) {
      localStorage.setItem("EjGtmId", "{}");
    }
    const gtmIdWrapper = localStorage.getItem("EjGtmId");
    const parsed = JSON.parse(gtmIdWrapper);
    if (document.referrer.includes("/ilan/")) {
      parsed.lastviewed = null;
      parsed.camefromdetail = parsed.listingdetail;
    } else if (document.referrer.includes("/projeler/proje/")) {
      parsed.lastviewed = null;
      parsed.camefromdetail = parsed.projectdetail;
    } else {
      parsed.camefromdetail = null;
    }
    if (
      (!isOtherPage || (parsed.lastviewed !== "listingsearch" && parsed.lastviewed !== "projectsearch")) &&
      parsed.lastviewed !== "listingmap"
    ) {
      parsed[type] = idCreator(32);
    }
    if (!document.referrer.includes("emlakjet.com")) {
      parsed.lastviewed = null;
      parsed.camefromdetail = null;
    }
    if (
      type === "homepage" ||
      type === "listingsearch" ||
      type === "projectsearch" ||
      type === "showcase" ||
      type === "agentdetail" ||
      type === "agentsearch" ||
      type === "listingmap"
    ) {
      parsed.lastviewed = type;
      parsed.camefromdetail = null;
    }
    localStorage.setItem("EjGtmId", JSON.stringify(parsed));
    resolve(parsed[type]);
  });
};

export default setSearchId;
